import { type Theme } from '#app/theme/index.js';
import { TextFieldContext } from './context.js';
import { StyledTextFieldInputAddon } from './TextFieldInputAddon.styles.js';
import {
  type ComponentPropsWithoutRef,
  forwardRef,
  type Ref,
  useContext,
} from 'react';

type TextFieldInputAddonProps = ComponentPropsWithoutRef<'div'> & {
  readonly appended?: boolean;
  // To curb the propensity for over customization, this prop is limited to black exclusively - @Boeing787
  readonly color?: Extract<keyof Theme['colors'], 'brandBlack'>;
};

export const TextFieldInputAddon = forwardRef(
  (
    { appended = false, children, color, ...props }: TextFieldInputAddonProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    const { isDisabled } = useContext(TextFieldContext);

    return (
      <StyledTextFieldInputAddon
        $appended={appended}
        $color={color}
        $isDisabled={isDisabled}
        ref={ref}
        {...props}
      >
        {children}
      </StyledTextFieldInputAddon>
    );
  },
);

TextFieldInputAddon.displayName = 'TextField.InputAddon';
